// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__vqP-F","bigColWidth":"Table_bigColWidth__1fiqQ","biggerColWidth":"Table_biggerColWidth__1HAfH","row":"Table_row__1gmVX","col":"Table_col__jyRlZ"};